// src/components/CommonTabs.js
import React from "react";
import CommonTabsCore from "./CommonTabs";
import { usePermissions } from "../../Utility/PermissionContext";

const CommonTabs = (props) => {
  const { role, subscriptionData, showLockPopup } = usePermissions();

  return (
    <CommonTabsCore
      {...props}
      role={role}
      subscriptionData={subscriptionData}
      showLockPopup={showLockPopup}
    />
  );
};

export default CommonTabs;